module.exports = __webpack_public_path__ + "static/media/30.b8260b9f.mp3";